











import { Component, Vue, Prop } from "vue-property-decorator";
import { DispatchNote } from "@/store/mobile/types";
import moment from "moment";

@Component
export default class GuardNoteItem extends Vue {
	@Prop()
	public note: DispatchNote;

	private getHumanTime(date: string) {
		return moment(date, ["DD/MM/YYYY HH:mm:ss", "M/D/YYYY h:mm:ss A", "DD/MM/YYYY HH:mm:ss ZZ"]).fromNow();
	}

	// Removes the author name from the note details (because it's easier to do this, than try and add to the author to the event details record)
	private removeAuthorFromNote(noteAuthor: string, noteContents: string) {
		return noteContents.replace(`${noteAuthor}:`, "");
	}
}
